import { useContext } from "react";
import { CigRegisterContext } from "./CigRegisterContextProvider";

const useCigRegisterContext = () => useContext(CigRegisterContext);

export default useCigRegisterContext;
